module.exports = __webpack_public_path__ + "img/Deco_automne.5f80331.jpg";